/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('main.cases.fill', {
      url: '/:id/response',
      template: '<fill></fill>',
    });
}



// WEBPACK FOOTER //
// ./client/app/cases/fill/fill.routes.js